import { render, staticRenderFns } from "./FilterMenuItem.vue?vue&type=template&id=0b3eaa97&scoped=true"
import script from "./FilterMenuItem.vue?vue&type=script&lang=ts"
export * from "./FilterMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./FilterMenuItem.vue?vue&type=style&index=0&id=0b3eaa97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3eaa97",
  null
  
)

export default component.exports